import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), 200)
  }

  submit() {
    if (this.element.value.length < 2) return

    const form = this.element.form
    if (form.dataset.turboFrame === "search_results") {
      const frame = document.getElementById("search_results")
      if (frame) frame.src = `/search?search[term]=${encodeURIComponent(this.element.value)}`
    } else {
      form.requestSubmit()
    }
  }
}
